import { gql } from "graphql-tag";
import {basePageableGraphqlField, responseField} from "../../../base.graphql";

// Define fields for warehouse
export const warehouseDetailedFields = `
            id
uniqueId
name
size
region {
    uniqueId
    name
}
distric {
    uniqueId
    name
}
ward {
    uniqueId
    name
}
`;

export const warehouseFields = `
id
uniqueId
name
size
sensorCount
recommendedCoveragePerSensor
zoneCount
assigneeCount
supervisor
region {
    uniqueId
    name
}
distric {
    uniqueId
    name
}
ward {
    uniqueId
    name
}
`;

// Queries
export const GET_ALL_MSD_WAREHOUSE = gql`
    query getAllWarehouses($filtering: WarehouseFilteringObject) {
        getAllWarehouses(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${warehouseFields}
            }
            page {
                ${basePageableGraphqlField}
            }
        }
    }`;

export const GET_ALL_MSD_WAREHOUSE_DETAILED = gql`
    query getAllWarehouses($filtering: WarehouseFilteringObject) {
        getAllWarehouses(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${warehouseDetailedFields}
            }
        }
    }`;

export const GET_WAREHOUSE_DASHBOARD = gql`
    query getWarehouseDashboard($filtering: WarehouseDashboardFilteringObject) {
        getWarehouseDashboard(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                totalWarehouses
                activeWarehouses
                inactiveWarehouses
                warehouseData {
                   ${warehouseFields}
                }
            }
        }
    }`;

// Mutations
export const REGISTER_WAREHOUSE_MUTATION = gql`
    mutation createWarehouseMutation($input: WarehouseInputObject!) {
        createWarehouseMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${warehouseFields}
            }
        }
    }`;

export const UPDATE_WAREHOUSE_MUTATION = gql`
    mutation updateWarehouseMutation($input: WarehouseInputObject!) {
        updateWarehouseMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${warehouseFields}
            }
        }
    }`;

export const DELETE_WAREHOUSE_MUTATION = gql`
    mutation deleteWarehouseMutation($uniqueId: String!) {
        deleteWarehouseMutation(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
        }
    }`;

export const DELETE_WAREHOUSE_DATA = gql`
    mutation deleteWarehouseData($id: ID!) {
        deleteWarehouseData(id: $id) {
            response {
                ${responseField}
            }
        }
    }`;